export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14865.a9993f7b.jpg";